<svg
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlns:xlink="http://www.w3.org/1999/xlink" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 24 24">
    <path d="M9.891 19.359l-6.984-1.359 0.375-2.016 4.922 0.984 1.594-8.109-1.828 0.703v3.422h-1.969v-4.688l5.203-2.203c0.281 0 0.516-0.094 0.797-0.094 0.703 0 1.266 0.375 1.688 0.984l0.984 1.594c0.797 1.406 2.391 2.391 4.313 2.391v2.016c-2.203 0-4.172-0.984-5.484-2.484l-0.609 3 2.109 1.969v7.5h-2.016v-6l-2.109-1.969zM13.5 5.484c-1.078 0-2.016-0.938-2.016-2.016s0.938-1.969 2.016-1.969 1.969 0.891 1.969 1.969-0.891 2.016-1.969 2.016z"></path>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-running.html